import {handleActions} from 'redux-actions';
import {Record, List, fromJS} from 'immutable';

import * as Actions from './actions';

const Table = Record({
    tableHeadHTML: '',
    tableRows: List(),
});

const ReportState = Record({
    fetching: true,
    from: null,
    tables: List(),
    groupBy: 'room',
    showChildLeaveAsAvailable: false,
    splitAt: '13:00',
});

const addNewTableDataFromAPI = (tables, tableFromAPI) => {
    const last = tables.last();
    if (last && last.tableHeadHTML === tableFromAPI.head) {
        return tables.set(
            -1,
            Table({
                tableHeadHTML: last.tableHeadHTML,
                tableRows: last.tableRows.concat(fromJS(tableFromAPI.body)),
            }),
        );
    } else {
        return tables.push(
            Table({
                tableHeadHTML: tableFromAPI.head,
                tableRows: fromJS(tableFromAPI.body),
            }),
        );
    }
};

export default handleActions(
    {
        [Actions.resetAndFetch.type]: (state, {payload}) =>
            new ReportState({
                groupBy: payload.groupBy,
                showChildLeaveAsAvailable: payload.showChildLeaveAsAvailable,
                splitAt: payload.splitAt,
            }),
        [Actions.resetAndFetchSuccess.type]: (state, {payload}) =>
            state.merge({
                fetching: false,
                tables: addNewTableDataFromAPI(state.tables, payload.response),
                from: payload.response.nextPeriod,
            }),
        [Actions.resetAndFetchFailed.type]: state =>
            state.merge({
                fetching: false,
            }),
        [Actions.fetch.type]: state =>
            state.merge({
                fetching: true,
            }),
        [Actions.fetchFailed.type]: state =>
            state.merge({
                fetching: false,
            }),
        [Actions.fetchSuccess.type]: (state, {payload}) =>
            state.merge({
                fetching: false,
                tables: addNewTableDataFromAPI(state.tables, payload.response),
                from: payload.response.nextPeriod,
            }),
    },
    new ReportState(),
);
